import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const OverviewDashboard = lazy(
    () => import('../components/OverviewDashboard')
);

const overviewDashboardRoute: RouteObject = {
    path: 'overview-old',
    element: <OverviewDashboard />,
};

export default overviewDashboardRoute;
